"use client"

import { clsx } from "clsx"

import { MULTICOLOR_HEXA, type COLOR_LABELS } from "~/lib/shopify/constants"
import { getProductColorByValue } from "~/lib/shopify/utils/get-product-color-by-value"
import Checkbox, { type CheckboxProps } from "~/components/ui/Checkbox"
import { ColorTranslation } from "~/components/ui/ColorTranslation"
import hexToHSL from "~/utils/hex-to-hsl"

import * as css from "../styles.css"

export function SwatchCheckbox({ name, value, selected }: CheckboxProps & { selected?: boolean }) {
  if (!value || !name) return null

  const hexa = getProductColorByValue(value as string)

  const isMulticolor = hexa === MULTICOLOR_HEXA

  const hsl = hexToHSL(hexa)
  const withBorder = hsl && hsl.l > 0.8

  return (
    <Checkbox
      checkmarkClassName={clsx(css.checkmarkColored[withBorder ? "withBorder" : "withoutBorder"], {
        [css.selected]: selected,
      })}
      checked={selected}
      contentClassName={css.checkbox}
      name={name}
      value={value}
      {...(hexa && {
        checkmarkStyle: {
          background: isMulticolor
            ? "linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,154,0,1) 10%, rgba(208,222,33,1) 20%, rgba(79,220,74,1) 30%, rgba(63,218,216,1) 40%, rgba(47,201,226,1) 50%, rgba(28,127,238,1) 60%, rgba(95,21,242,1) 70%, rgba(186,12,248,1) 80%, rgba(251,7,217,1) 90%, rgba(255,0,0,1) 100%)"
            : hexa,
        },
      })}
      id={`${value}${hexa ?? ""}`}
    >
      <ColorTranslation tKey={value as keyof typeof COLOR_LABELS} />
    </Checkbox>
  )
}
